import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonicalUrl,
  ogImage,
  ogType = 'website',
  structuredData
}) => {
  const siteTitle = 'Ayati Constructions';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} | Premium High-Rise Construction Contractor in Hyderabad`;
  const defaultDescription = 'Ayati Constructions and Estates LLP - Leading construction contractor in Hyderabad specializing in high-rise buildings, commercial complexes, and residential projects. 200+ professionals, 2 Cr+ sq.ft built.';
  const defaultKeywords = 'construction contractor Hyderabad, high-rise construction, building contractor, Ayati Constructions, commercial construction, residential construction';
  const defaultImage = 'https://www.ayaticonstructions.com/og-image.jpg';
  const baseUrl = 'https://www.ayaticonstructions.com';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={`${baseUrl}${canonicalUrl}`} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl ? `${baseUrl}${canonicalUrl}` : baseUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={ogImage || defaultImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl ? `${baseUrl}${canonicalUrl}` : baseUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description || defaultDescription} />
      <meta property="twitter:image" content={ogImage || defaultImage} />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
